module.exports = __webpack_public_path__ + "static/media/IMG_4272.7279a6f2.PNG";